import { createSearchParams } from '@integration-frontends/integration/core/model';
import { takeEvery } from 'redux-saga/effects';
import { put, select } from 'typed-redux-saga';
import { searchAssetsSelectors } from '../../../selectors';
import { clearSearch, search } from '../actions';

function* handler(action: ReturnType<typeof clearSearch>) {
  // mainain sort options when clearing search
  const sortOptions = yield select(searchAssetsSelectors.sortOptions);

  if (action.payload.executeSearch) {
    yield put(search({ searchParams: createSearchParams(), sortOptions }));
  }
}

export function* clearSearchEffects() {
  yield takeEvery(clearSearch, handler);
}
